class FormApp extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Set up Mutation Observer
    this.observer = new MutationObserver((mutations, observer) => {
      const formWidget = document.querySelector('form-embed')

      if (formWidget) {
        this.injectFormStyles(formWidget)

        observer.disconnect() // Stop observing once the carousel is setup

        // Clear the timeout if productCard is found
        clearTimeout(this.timeoutId)
      }
    })

    // Observe body for changes
    this.observer.observe(document.body, { childList: true, subtree: true })

    // Set up a timeout to stop observing after 5 seconds if the node isn't found
    this.timeoutId = setTimeout(() => {
      this.observer.disconnect()
    }, 5000)
  }

  injectFormStyles (formEmbedEl) {
    if (formEmbedEl.shadowRoot) {
      const style = document.createElement('style')
      style.textContent = this.formStyles

      formEmbedEl.shadowRoot.appendChild(style)
    }
  }

  get formStyles () {
    return `
      /* BAO Custom Override styles */
      :host {
        --forms-body-font: normal 300 14px var(--Font_Family-domaineText);

        --form-field-border: 0 0 0 1px #0000001A;
        --form-field-border-focused: 0 0 0 1px #333333;

        --container-text-alignment: left;
      }

      #app-embed ._formContainer_stahb_30 {
        max-width: 100%;
        margin: 0;
      }
        
      #app-embed ._formHeader_1nihh_19 {
        margin: 0 0 10px;
      }

      #app-embed h2 {
        margin-block-start: 20px;
        margin-block-end: 5px;

        font-family: var(--Font_Family-domaineDisplayNarrow);
        font-size: 28px;
        font-weight: 400;
        letter-spacing: -0.01em;
        line-height: 130%;

        @media (width > 1200px) {
          font-size: 38px;
        }
      }

      #app-embed h3 {
        margin-block-start: 20px;
        margin-block-end: 5px;

        font-family: var(--Font_Family-domaineDisplayNarrow);
        font-size: 18px;
        font-weight: 400;
        letter-spacing: -0.01em;
        line-height: 130%;

        @media (width > 1200px) {
          font-size: 28px;
        }
      }

      #app-embed ._textBody_2aowh_10 {
        margin-block-start: 10px;
      }

      #app-embed label._formInputFieldLabel_1ydxd_37 {
        top: var(--input-label-top) !important;
      }

      #app-embed ._label_1yit2_10 {
        margin-block: 20px 10px;
      }

      #app-embed ._selectorError_1yit2_50,
      #app-embed div._withError_1ydxd_16 > input,
      #app-embed ._invalid_17mgw_14 {
        box-shadow: 0 0 0 1px var(--form-error-color);
      }

      #app-embed ._formError_1ydxd_20,
      #app-embed ._error_1o4ef_1 {
        margin: 0 0 5px;

        font-family: var(--Font_Family-segma);
        font-size: 12px;
        font-weight: 400;
        line-height: 140%;
      }

      #app-embed ._error_1o4ef_1 {
        margin-top: 5px;
      }

      #app-embed button[type='submit'] {
        font-family: var(--Font_Family-segma);
        font-size: 12px;
        font-weight: 400;
        text-transform: uppercase;

        background-color: var(--Color_Brand);
        border-radius: 4px;

        transition: background-color 0.3s ease;
      }
      #app-embed button[type='submit']:hover {
        background-color: var(--Color_Olive);
        filter: none;
      }
    `
  }
}

if (!customElements.get('form-app')) {
  customElements.define('form-app', FormApp)
}
